import { ChangeDetectorRef, Component, ComponentFactoryResolver, Inject, OnInit, ViewChild } from '@angular/core';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { IDac6ReporterState } from '../../store/reducers/dac6-reporter.reducer';
import { CellEditorComponentBase } from '@shared/components/cell-components/cell-component';
import { CellContainerHostDirective } from '@shared/directive/cell-container-host.directive';
import { ParticleService } from '@core/services/particle.service';
import { SmartGridService } from '@core/services/smart-grid.service';
import { TimeZoneService } from '@core/services/time-zone.service';
import { CellEditorData } from '@shared/models/cell-editor-data.model';
import { CellEditorActionData } from '@shared/models/cell-editor-action-data.model';
import {UpdateParticipantsCommand} from '../../commands/dac6-reporter.command';
import {Configuration} from '@shared/models/configuration';
import {CommandService} from '@core/services/command.service';
import {SnackBarService} from "@core/services/snack-bar.service";


@Component({
    standalone: false,
    selector: 'lib-dac6-cell-editor-container',
  templateUrl: './dac6-cell-editor-container.component.html',
  styleUrls: ['./dac6-cell-editor-container.component.scss']
})
export class Dac6CellEditorContainerComponent implements OnInit {

  cellEditorComponent: CellEditorComponentBase;
  transactionId: string;
  fieldKey: string;
  isValid = true;
  @ViewChild(CellContainerHostDirective, {static: true}) particleCellContainerHost: CellContainerHostDirective;

  constructor(private componentFactoryResolver: ComponentFactoryResolver,
              private particleService: ParticleService,
              private commandService: CommandService,
              private snackBarService: SnackBarService,
              private smartGridService: SmartGridService,
              private timeZoneService: TimeZoneService,
              private matDialogRef: MatDialogRef<Dac6CellEditorContainerComponent>,
              private store: Store<IDac6ReporterState>,
              private changeDetectorRef: ChangeDetectorRef,
              @Inject(MAT_DIALOG_DATA) public cellEditorData: CellEditorData) {

  }

  ngOnInit() {
    const currentComponent = this.particleService.getCellComponent(this.cellEditorData.fieldDefinition.cellEditor);
    // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(currentComponent);
    this.particleCellContainerHost.viewContainerRef.clear();
    const component = this.particleCellContainerHost.viewContainerRef.createComponent(currentComponent);
    this.cellEditorComponent = component.instance as CellEditorComponentBase;
    this.cellEditorComponent.item = this.cellEditorData.item;
    this.cellEditorComponent.fieldDefinition = this.cellEditorData.fieldDefinition;
    this.cellEditorComponent.sourceType = this.cellEditorData.sourceType;
    if (this.cellEditorComponent.valueChanged) {
      this.cellEditorComponent.valueChanged.subscribe((value: CellEditorActionData) => this.onValueChange(value));
    }
    if (this.cellEditorComponent.validationChange) {
      this.cellEditorComponent.validationChange.subscribe((value: boolean) => this.onValidationChange(value));
    }
    this.transactionId = this.cellEditorData.item.id;
    this.fieldKey = this.cellEditorData.fieldDefinition.key;
  }

  onValueChange(value: CellEditorActionData) {

  }

  onValidationChange (value: boolean) {
    this.isValid = value;
    this.changeDetectorRef.detectChanges();
  }

  okClicked() {
    if (this.cellEditorComponent.dynamicFormControl) {
      if (this.cellEditorComponent.isEdited()) {
        const editedValue = this.cellEditorComponent.getEditedValue();
        const fieldValues = {};
        fieldValues[this.cellEditorData.fieldDefinition.key] = editedValue;
        // const command = new TransactionsUpdateCommand({'fieldValues': fieldValues, 'Id': this.transactionId});
        // this.store.dispatch(new PostCellEditorValueAction(command, this.matDialogRef, this.cellEditorData.sourceType));
      } else {
        this.cancelClicked();
      }
    } else if (this.cellEditorComponent.fieldDefinition.key === 'Ownership') {
      const data = this.cellEditorComponent.getUpdatedData();
      if (!data.data) {
        return;
      }
      const fieldValues = {};
      fieldValues[this.cellEditorData.fieldDefinition.key] = data.data.value;
      const sourceType = this.cellEditorData.sourceType;
      let updateEndpoint = '';
      switch (sourceType) {
        case 'Relevant-Taxpayers':
          updateEndpoint = `${Configuration.getConfig('Dac6Api')}Command/UpdateRelevantTaxpayer`;
          break;
        case 'Intermediaries':
          updateEndpoint = `${Configuration.getConfig('Dac6Api')}Command/UpdateIntermediary`;
          break;
        case 'Other-Persons':
          updateEndpoint = `${Configuration.getConfig('Dac6Api')}Command/UpdateOtherPerson`;
          break;
      }
      const item = {id: this.cellEditorData.item.id, fieldValues: fieldValues};
      const command = new UpdateParticipantsCommand(item, updateEndpoint);
      const cellEditorActionData = <CellEditorActionData>{
        clickedButtonName: 'Ok',
        data: this.cellEditorData,
        rowId: this.cellEditorData.item.id
      };
      this.commandService.executeCommand(command).pipe().subscribe(() => {
        if (this.cellEditorData.invalidateSubject) {
          this.cellEditorData.invalidateSubject.invalidate();
        }
        this.matDialogRef.close(cellEditorActionData);
      }, () => {
        this.snackBarService.showError('Ownerships update failed.');
        this.matDialogRef.close(cellEditorActionData);
      });
    } else {
      const data = this.cellEditorComponent.getUpdatedData();
      if (!data.data) {
        return;
      }
      const fieldValues = {};
      fieldValues[this.cellEditorData.fieldDefinition.key] = data.data.value;
      this.matDialogRef.close(true);
      // const command = new TransactionsUpdateCommand({'fieldValues': fieldValues, 'Id': this.transactionId});
      // this.store.dispatch(new PostCellEditorValueAction(command, this.matDialogRef, this.cellEditorData.sourceType));
    }
  }

  cancelClicked() {
    this.matDialogRef.close();
  }

}
